module.exports = __webpack_public_path__ + "static/media/plus.b606cb11.svg";